module.exports = __webpack_public_path__ + "assets/img/wback4.34063d94.png";